import { inject, injectable } from "inversify";
import { Subscribable, SubscribableOrValue } from "knockout";
import { wccModules } from "../../../../enums/wccModules";
import { IWCCStorageManager } from "../../../../managers/iStorage";
import TopicAttachmentsManager from "../../../../managers/topic/attachments";
import WCCAttachment from "../../../../models/attachments/attachment";
import WCCImage from "../../../../models/attachments/image";
import './instructionsHeader.html';
import './instructionsHeader.scss';

export interface TopicSummaryInstructionsHeaderVMConfig {
    topicId?: SubscribableOrValue<string | undefined>
}

@injectable()
export default class TopicSummaryInstructionsHeaderVM {
    labels = labels;

    title: Subscribable<string>

    constructor(
        @inject(wccModules.componentConfig) config: TopicSummaryInstructionsHeaderVMConfig,
        @inject(wccModules.componentInfo) info: ko.components.ComponentInfo,
        @inject(wccModules.storage) storage: IWCCStorageManager
    ) {
        const topicId = ko.flattenComputed(config.topicId);

        const attachmentsManager = storage.get(TopicAttachmentsManager, { topicId });
        const attachments = attachmentsManager.pluck(m => m.attachments, []);
        const hasNoSummaryImage = ko.pureComputed(() => !this.hasSummaryImage(attachments()));
        
        var isReady = ko.pureComputed(() => hasNoSummaryImage());

        this.title = ko.observable(labels.Instructions); 

        ko.applyBindingsToNode(info.element, {
            'visible': isReady
        }, this);
    }

    hasSummaryImage(attachments: Array<WCCAttachment>) {        
        let possibleImage = <WCCImage | undefined>attachments.find(attachment => attachment.fileType() === enums.AttachmentTypes.ActivityInstructionsImage.value);        

        return possibleImage?.hqUrl != undefined;
    }
}